import { createContext, useContext, useState, useCallback } from 'react';

const RailContext = createContext(null);

export function useRail() {
    const ctx = useContext(RailContext);
    if (!ctx) throw new Error('useRail must be used within <RailProvider>');
    return ctx;
}

export function RailProvider({ children }) {
    const [items, setItems] = useState(null);
    const [openIndex, setOpenIndex] = useState(null);

    const register = useCallback((newItems) => {
        setItems(newItems);
        setOpenIndex(null);
    }, []);

    const unregister = useCallback(() => {
        setItems(null);
        setOpenIndex(null);
    }, []);

    const selectItem = useCallback((index) => {
        setOpenIndex((prev) => (prev === index ? null : index));
    }, []);

    const deselectAll = useCallback(() => {
        setOpenIndex(null);
    }, []);

    return (
        <RailContext.Provider value={{ items, openIndex, register, unregister, selectItem, deselectAll }}>
            {children}
        </RailContext.Provider>
    );
}
